"use strict";
(() => {
  // src/scripts/components/disruptor-tile.js
  var DisruptorTileHeightMatcher = class {
    constructor() {
      this.selectors = {
        productCard: ".card__inner",
        wideTile: ".disruptor-tile--layout-wide .disruptor-tile",
        portraitTile: ".disruptor-tile--layout-portrait .disruptor-tile",
        facetsWrapper: ".facets-wrapper-TWP--vertical",
        productGridContainer: "#ProductGridContainer"
      };
      this.desktopMediaQuery = window.matchMedia("(min-width: 990px)");
      this.resizeTimeout = null;
      this.filterTransitionDelay = 350;
      this.init();
    }
    init() {
      this.matchHeights();
      window.addEventListener("resize", () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => this.matchHeights(), 150);
      });
      this.desktopMediaQuery.addEventListener("change", () => this.matchHeights());
      window.addEventListener("load", () => this.matchHeights());
      this.observeFilterSidebar();
      this.observeProductGrid();
    }
    /**
     * Watch for filter sidebar open/close
     */
    observeFilterSidebar() {
      const facetsWrapper = document.querySelector(this.selectors.facetsWrapper);
      if (!facetsWrapper) return;
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            setTimeout(() => this.matchHeights(), this.filterTransitionDelay);
          }
        });
      });
      observer.observe(facetsWrapper, {
        attributes: true,
        attributeFilter: ["class"]
      });
    }
    /**
     * Watch for product grid content changes (filter AJAX updates)
     */
    observeProductGrid() {
      const productGridContainer = document.querySelector(this.selectors.productGridContainer);
      if (!productGridContainer) return;
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" || mutation.type === "subtree") {
            setTimeout(() => this.matchHeights(), 100);
          }
        });
      });
      observer.observe(productGridContainer, {
        childList: true,
        subtree: true
      });
    }
    matchHeights() {
      const productCards = document.querySelectorAll(this.selectors.productCard);
      const wideTiles = document.querySelectorAll(this.selectors.wideTile);
      const portraitTiles = document.querySelectorAll(this.selectors.portraitTile);
      if (!productCards.length) return;
      const cardHeight = productCards[0].offsetHeight;
      if (cardHeight > 0) {
        if (wideTiles.length) {
          wideTiles.forEach((tile) => {
            tile.style.height = `${cardHeight}px`;
          });
        }
        if (portraitTiles.length) {
          if (this.desktopMediaQuery.matches) {
            portraitTiles.forEach((tile) => {
              tile.style.height = `${cardHeight}px`;
            });
          } else {
            const mobileGap = 40;
            const portraitMobileHeight = cardHeight * 2 + mobileGap;
            portraitTiles.forEach((tile) => {
              tile.style.height = `${portraitMobileHeight}px`;
            });
          }
        }
      }
    }
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => new DisruptorTileHeightMatcher());
  } else {
    new DisruptorTileHeightMatcher();
  }
})();
